import {DetailsField, DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {useTranslation} from '@/translations/i18n'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '../../types'
import {Text} from '@/components/ui/text/Text'
import {ReferringSpecialistEditDialog} from '@/features/projects/components/referring-specialist-edit-dialog/ReferringSpecialistEditDialog'
import {projectSenderToLabel} from '@/features/projects/utils'
import {WarningLabel} from '@/components/ui/warning-label/WarningLabel'
import {specialistTitleMapToLabel} from '@/features/referring-specialists/utils'

export const ProjectDetailsReferringSpecialistSection = () => {
    const {t} = useTranslation()
    const {project, isEditable} = useOutletContext<{project: ProjectExtended; isEditable: boolean}>()

    return (
        <DetailsFieldsSection
            variant="primary"
            title={t('projects:referring_entity')}
            headingEndSlot={isEditable && <ReferringSpecialistEditDialog project={project} />}
        >
            <Grid columns={2} gap={3} fullWidth>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:select_sender_label')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {project.sender ? (
                            t(projectSenderToLabel[project.sender])
                        ) : (
                            <WarningLabel text={t('users:to_compile')} />
                        )}
                    </Text>
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:sender')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {project.specialist?.firstName && project.specialist?.lastName ? (
                            `${project.specialist.title && t(specialistTitleMapToLabel[project.specialist.title]) + ' '}${project.specialist.lastName} ${project.specialist.firstName}`
                        ) : (
                            <WarningLabel text={t('users:to_compile')} />
                        )}
                    </Text>
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('projects:specialist_service_uoc')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {project.specialist?.serviceUoc || <WarningLabel text={t('users:to_compile')} />}
                    </Text>
                </DetailsField>
                <DetailsField fullWidth>
                    <Text palette="neutral" shade="500" size="textSm">
                        {t('commons:email')}
                    </Text>
                    <Text palette="neutral" shade="950" size="textSm" weight="500">
                        {project.specialist?.email ? (
                            project.specialist.email
                        ) : (
                            <WarningLabel text={t('users:to_compile')} />
                        )}
                    </Text>
                </DetailsField>
            </Grid>
        </DetailsFieldsSection>
    )
}
